import React from 'react';
import { TrophyIcon, UsersIcon, BookOpenIcon, QuoteIcon } from 'lucide-react';
const stats = [{
  icon: TrophyIcon,
  value: '+15',
  label: 'Años en alto rendimiento'
}, {
  icon: UsersIcon,
  value: '+2.000',
  label: 'Coaches formados'
}, {
  icon: BookOpenIcon,
  value: '+50',
  label: 'Clubes acompañados'
}];
export function ExpertSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4 border-t border-border-light/50 relative overflow-hidden" data-id="element-187">
      {/* Ambient glows */}
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-primary/8 rounded-full blur-[140px] pointer-events-none" aria-hidden="true" data-id="element-188"></div>
      <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-cta-green/5 rounded-full blur-[120px] pointer-events-none" aria-hidden="true" data-id="element-189"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-190">
        {/* Section eyebrow */}
        <div className="text-center mb-10 sm:mb-14" data-id="element-191">
          <span className="inline-block text-primary font-bold text-xs sm:text-sm tracking-widest uppercase bg-primary/10 px-4 py-1.5 rounded-full border border-primary/20" data-id="element-192">
            🏉 Quiénes estamos detrás
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mt-4 tracking-tight" data-id="element-193">
            Acerca de <span className="text-primary" data-id="element-194">EDULABS™</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-8 items-stretch" data-id="element-195">
          {/* Brand card */}
          <div className="lg:col-span-2 bg-bg-alt border border-border-light rounded-3xl p-7 sm:p-9 relative overflow-hidden flex flex-col" data-id="element-196">
            {/* Top accent */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary via-secondary to-cta-green" aria-hidden="true" data-id="element-197"></div>

            {/* Logo / Mark */}
            <div className="flex items-center gap-4 mb-6" data-id="element-198">
              <div className="relative flex-shrink-0" data-id="element-199">
                <div className="absolute inset-0 bg-primary/30 blur-xl rounded-2xl" aria-hidden="true" data-id="element-200"></div>
                <div className="relative w-16 h-16 bg-gradient-to-br from-primary to-blue-700 rounded-2xl flex items-center justify-center text-3xl shadow-[0_0_25px_rgba(59,130,246,0.5)] border border-white/20" data-id="element-201">
                  🏉
                </div>
              </div>
              <div data-id="element-202">
                <p className="text-text-main font-black text-2xl tracking-tight leading-none" data-id="element-203">
                  EDULABS
                  <span className="text-primary text-base align-top" data-id="element-204">™</span>
                </p>
                <p className="text-text-sec text-xs tracking-widest uppercase mt-1.5 font-bold" data-id="element-205">
                  Coaching · Rugby · Performance
                </p>
              </div>
            </div>

            <p className="text-text-sec text-sm sm:text-base leading-relaxed mb-6 flex-grow" data-id="element-206">
              Somos un equipo de entrenadores y educadores deportivos
              especializados en convertir conocimiento de élite en herramientas
              <span className="text-text-main font-bold" data-id="element-207">
                {' '}
                prácticas y aplicables{' '}
              </span>
              para coaches de toda Hispanoamérica.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-2 pt-5 border-t border-border-light" data-id="element-208">
              {stats.map((stat, i) => {
              const Icon = stat.icon;
              return <div key={i} className="text-center" data-id="element-209">
                    <Icon className="w-5 h-5 text-primary mx-auto mb-1.5" aria-hidden="true" data-id="element-210" />
                    <div className="text-text-main font-black text-lg sm:text-xl tracking-tight" data-id="element-211">
                      {stat.value}
                    </div>
                    <div className="text-text-sec text-[10px] sm:text-xs leading-tight font-medium" data-id="element-212">
                      {stat.label}
                    </div>
                  </div>;
            })}
            </div>
          </div>

          {/* Mission / Quote card */}
          <div className="lg:col-span-3 bg-gradient-to-br from-bg-alt to-bg-alt/60 border border-primary/30 rounded-3xl p-7 sm:p-10 relative overflow-hidden flex flex-col justify-center shadow-[0_0_40px_rgba(59,130,246,0.1)]" data-id="element-213">
            {/* Decorative quote */}
            <QuoteIcon className="absolute top-6 left-6 w-14 h-14 sm:w-20 sm:h-20 text-primary/15" strokeWidth={1.5} aria-hidden="true" data-id="element-214" />
            <div className="absolute -bottom-10 -right-10 w-64 h-64 bg-primary/10 rounded-full blur-3xl pointer-events-none" aria-hidden="true" data-id="element-215"></div>

            <div className="relative z-10 pl-2 sm:pl-6" data-id="element-216">
              <p className="text-primary font-bold text-xs sm:text-sm tracking-widest uppercase mb-4" data-id="element-217">
                Nuestra misión
              </p>
              <blockquote className="text-text-main text-lg sm:text-2xl leading-relaxed font-medium mb-6" data-id="element-218">
                Hemos volcado en este sistema la experiencia de años en clubes
                de alto nivel para que el entrenador de campo{' '}
                <span className="text-primary font-bold" data-id="element-219">
                  no tenga que perder tiempo en la teoría
                </span>{' '}
                y pueda enfocarse en lo que importa:{' '}
                <span className="text-text-main font-black" data-id="element-220">
                  mejorar a sus jugadores.
                </span>
              </blockquote>

              {/* Signature */}
              <div className="flex items-center gap-3 pt-5 border-t border-border-light" data-id="element-221">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary to-blue-700 flex items-center justify-center font-black text-white text-sm shadow-md" data-id="element-222">
                  E
                </div>
                <div data-id="element-223">
                  <p className="text-text-main font-bold text-sm" data-id="element-224">
                    Equipo EDULABS™
                  </p>
                  <p className="text-text-sec text-xs" data-id="element-225">
                    Coaches & Educadores Deportivos
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}